"use client";

import { useEffect } from "react";

export function NavTitleFix() {
	useEffect(() => {
		function fix() {
			const links = document.querySelectorAll<HTMLAnchorElement>(
				'a[href="https://silkdock.ai"]',
			);
			links.forEach((link) => link.removeAttribute("target"));
		}

		fix();

		const observer = new MutationObserver(fix);
		observer.observe(document.body, { childList: true, subtree: true });

		return () => observer.disconnect();
	}, []);

	return null;
}
